<template>
  <JadeSpinner v-if="loadingChargeback" />
  <div
    class="mb-6"
    v-else
  >
    <div class="mb-6">
      <JadeAlert
        v-if="shouldDisplayAlert"
        variant="warning"
        showIcon
      >
        <JadeText
          variant="warning"
          color="current-color"
        >
          {{ $t('alert-title-1') }}
          <b>{{ remainingDays }} {{ $t('alert-title-2') }}</b>
          {{ $t('alert-title-3') }}
        </JadeText>
      </JadeAlert>
    </div>

    <div class="w-full flex justify-center">
      <jade-page-container size="wide">
        <ChargebackDetailsData
          :amount="chargebackData.amount"
          :chargebackId="chargebackId"
          :cardFirstDigits="chargebackData.cardFirstDigits"
          :cardBrand="chargebackData.cardBrand"
          :cardHolderName="chargebackData.cardHolderName"
          :cardNumber="chargebackData.cardNumber"
          :createdAt="chargebackData.createdAt"
          :customerDocument="chargebackData.customerDocument"
          :email="chargebackData.email"
          :reasonDescription="chargebackData.reasonDescription"
          :statusCode="chargebackData.status"
        />

        <template #aside>
          <div class="w-280 shrink-0">
            <div
              v-if="shouldDisplayDisputeButton"
              class="mb-4"
            >
              <JadeButton
                @click="redirectToRepresentment"
                class="w-full"
                variant="primary-solid"
              >
                {{ $t('create-dispute') }}
              </JadeButton>
            </div>
            <ChargebackDetailsTimeline
              :createdAt="chargebackData.createdAt"
              :statusCode="chargebackData.status"
            />
          </div>
        </template>
      </jade-page-container>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ChargebackDetailsManager from './chargeback-details.manager.js'
import ChargebackDetailsData from './ChargebackDetailsData.vue'
import ChargebackDetailsTimeline from './ChargebackDetailsTimeline.vue'

import {
  JadeAlert,
  JadeButton,
  JadeText,
  JadePageContainer,
  JadeSpinner
} from '@jade'

export default {
  name: 'ChargebackDetails',
  components: {
    ChargebackDetailsTimeline,
    ChargebackDetailsData,
    JadeButton,
    JadeAlert,
    JadeText,
    JadePageContainer,
    JadeSpinner
  },
  computed: {
    ...mapGetters(['chargeback', 'loadingChargeback']),
    chargebackDetailsManager () {
      return new ChargebackDetailsManager(this.chargeback)
    },
    chargebackData () {
      return this.chargebackDetailsManager.detailsAdapter
    },
    chargebackId () {
      return this.$route.params.chargeback_id
    },
    merchantId () {
      return this.$route.params.merchant_id
    },
    accountId () {
      return this.$route.params.account_id
    },
    shouldDisplayDisputeButton () {
      return this.chargebackDetailsManager.shouldDisplayDisputeButton
    },
    shouldDisplayAlert () {
      return this.chargebackDetailsManager.shouldDisplayAlert
    },
    remainingDays () {
      return ChargebackDetailsManager.remainingDays(
        this.chargebackData.createdAt
      )
    }
  },
  methods: {
    redirectToRepresentment () {
      this.$router.push({
        path: `/${this.merchantId}/${this.accountId}/chargebacks/${this.chargebackId}/representment`
      })
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "alert-title-1": "Você tem",
      "alert-title-2": "dias restantes",
      "alert-title-3": "para abrir uma disputa desta contestação.",
      "create-dispute": "Disputar contestação"
    },
    "en-US" : {
      "alert-title-1": "You have",
      "alert-title-2": "days remaining",
      "alert-title-3": "to open a chargeback dispute.",
      "create-dispute": "Disputar contestação"
    }
  }
</i18n>
